// hooks/weeklyOff/useWeeklyOffSearch.ts
import { useState, useCallback, useEffect } from "react";
import type * as type from "@vTypes";
import { toast } from "@/components/toast/CustomToast";

export function useWeeklyOffSearch(nurses: type.FullNurseSchema[] | undefined) {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [highlightedNurseId, setHighlightedNurseId] = useState<string | null>(
    null
  );

  // 검색 실행 함수
  const handleSearch = useCallback(() => {
    if (!searchTerm.trim()) {
      setHighlightedNurseId(null);
      return;
    }

    // 전체 간호사 목록에서 이름으로 검색
    const foundNurse = nurses?.find(
      (nurse) => nurse.name === searchTerm.trim()
    );

    if (foundNurse) {
      setHighlightedNurseId(foundNurse.nurse_id);
    } else {
      setHighlightedNurseId(null);
      toast.error(`"${searchTerm}" 이름을 가진 간호사를 찾을 수 없습니다.`);
    }
  }, [searchTerm, nurses]);

  // 엔터 키 핸들러
  const handleSearchKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch]
  );

  // 검색어 변경 시 하이라이트 초기화
  const handleSearchTermChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(e.target.value);
      setHighlightedNurseId(null);
    },
    []
  );

  // 하이라이트된 요소로 스크롤
  useEffect(() => {
    if (highlightedNurseId) {
      setTimeout(() => {
        const element = document.querySelector(
          `[data-nid="${highlightedNurseId}"]`
        ) as HTMLElement;

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }
  }, [highlightedNurseId]);

  // 검색 초기화
  const resetSearch = useCallback(() => {
    setSearchTerm("");
    setHighlightedNurseId(null);
  }, []);

  return {
    // 상태
    searchTerm,
    highlightedNurseId,

    // 핸들러
    handleSearch,
    handleSearchKeyDown,
    handleSearchTermChange,
    resetSearch,
  };
}
